export default "__VITE_ASSET__76e5f350__"